import React from "react";

import "../css/FactoryAutomationPage.css";

import FactoryAutomationVideoCard_1 from "./FactoryAutomationVideoCard_1";
import FactoryAutomationVideoCard_2 from "./FactoryAutomationVideoCard_2";
import FactoryAutomationVideoCard_3 from "./FactoryAutomationVideoCard_3";
import FactoryAutomationVideoCard_4 from "./FactoryAutomationVideoCard_4";
import FactoryAutomationVideoCard_5 from "./FactoryAutomationVideoCard_5";

import FactoryAutomationVideoPlayer_1 from "./FactoryAutomationVideoPlayer_1";
import FactoryAutomationVideoPlayer_2 from "./FactoryAutomationVideoPlayer_2";
import FactoryAutomationVideoPlayer_3 from "./FactoryAutomationVideoPlayer_3";
import FactoryAutomationVideoPlayer_4 from "./FactoryAutomationVideoPlayer_4";
import FactoryAutomationVideoPlayer_5 from "./FactoryAutomationVideoPlayer_5";

const FactoryAutomationPage = () => {
  return (
    <>
      <div className="factory-automation-page body white-letter centered-text">
        Here are some videos about my expertise leading Automation Projects, I
        want to share with you my capabilities and experience as Automation
        Manager, that means these are projects where I manage a team of
        Automation Engineers and all efforts to deliver this sucessfull projects
        were made by a Team, I hope you enjoy them.
        <div className="my-rows">
          <FactoryAutomationVideoPlayer_1 />
          <FactoryAutomationVideoCard_1 />
        </div>
        <div className="my-rows">
          <FactoryAutomationVideoPlayer_2 />
          <FactoryAutomationVideoCard_2 />
        </div>
        <div className="my-rows">
          <FactoryAutomationVideoPlayer_3 />
          <FactoryAutomationVideoCard_3 />
        </div>
        <div className="my-rows">
          <FactoryAutomationVideoPlayer_4 />
          <FactoryAutomationVideoCard_4 />
        </div>
        <div className="my-rows"> 
          <FactoryAutomationVideoPlayer_5 />
          <FactoryAutomationVideoCard_5 />
        </div>
      </div>
    </>
  );
};

export default FactoryAutomationPage;
